const API_URL = process.env.REACT_APP_API_URL || 'https://expendiente.doctorweb.agency/api';

const headers = {
  'Content-Type': 'application/json',
};

// Funciones para autenticación
export const loginUser = async (email, password) => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) throw new Error('Credenciales inválidas');
    return await response.json();
  } catch (error) {
    console.error('Error en login:', error);
    throw error;
  }
};

// Funciones para usuarios
export const loadUsers = async () => {
  try {
    const response = await fetch(`${API_URL}/users`);
    if (!response.ok) throw new Error('Error al cargar usuarios');
    return await response.json();
  } catch (error) {
    console.error('Error al cargar usuarios:', error);
    throw error;
  }
};

export const createUser = async (user) => {
  try {
    console.log('=== FRONTEND createUser ===');
    console.log('createUser - datos originales:', JSON.stringify(user));
    console.log('createUser - cells originales:', JSON.stringify(user.cells), 'tipo:', typeof user.cells);
    
    // Procesar el array de células antes de enviarlo al servidor
    const processedUser = { ...user };
    
    if (processedUser.cells) {
      console.log('createUser - procesando cells');
      // Convertir el array de células a una cadena simple separada por comas
      if (Array.isArray(processedUser.cells)) {
        console.log('createUser - cells es array, procesando');
        processedUser.cells = processedUser.cells
          .filter(cell => cell && typeof cell === 'string' && cell.trim())
          .map(cell => cell.trim())
          .join(',');
        console.log('createUser - cells después de join:', processedUser.cells);
      } else if (typeof processedUser.cells === 'string') {
        console.log('createUser - cells es string, limpiando');
        // Si ya es un string, limpiarlo
        processedUser.cells = processedUser.cells.trim();
      } else {
        console.log('createUser - cells es otro tipo, estableciendo vacío');
        processedUser.cells = '';
      }
      
      // Si está vacío, establecer como null
      if (!processedUser.cells) {
        console.log('createUser - cells vacío, estableciendo null');
        processedUser.cells = null;
      }
    }
    
    console.log('createUser - datos procesados:', JSON.stringify(processedUser));
    console.log('createUser - cells final:', JSON.stringify(processedUser.cells));
    
    const response = await fetch(`${API_URL}/users`, {
      method: 'POST',
      headers,
      body: JSON.stringify(processedUser),
    });
    if (!response.ok) throw new Error('Error al crear usuario');
    return await response.json();
  } catch (error) {
    console.error('Error al crear usuario:', error);
    throw error;
  }
};

export const updateUser = async (email, updates) => {
  try {
    console.log('=== FRONTEND updateUser ===');
    console.log('updateUser - datos originales:', JSON.stringify(updates));
    console.log('updateUser - cells originales:', JSON.stringify(updates.cells), 'tipo:', typeof updates.cells);
    
    // Procesar el array de células antes de enviarlo al servidor
    const processedUpdates = { ...updates };
    
    if (processedUpdates.cells) {
      console.log('updateUser - procesando cells');
      // Convertir el array de células a una cadena simple separada por comas
      if (Array.isArray(processedUpdates.cells)) {
        console.log('updateUser - cells es array, procesando');
        processedUpdates.cells = processedUpdates.cells
          .filter(cell => cell && typeof cell === 'string' && cell.trim())
          .map(cell => cell.trim())
          .join(',');
        console.log('updateUser - cells después de join:', processedUpdates.cells);
      } else if (typeof processedUpdates.cells === 'string') {
        console.log('updateUser - cells es string, limpiando');
        // Si ya es un string, limpiarlo
        processedUpdates.cells = processedUpdates.cells.trim();
      } else {
        console.log('updateUser - cells es otro tipo, estableciendo vacío');
        processedUpdates.cells = '';
      }
      
      // Si está vacío, establecer como null
      if (!processedUpdates.cells) {
        console.log('updateUser - cells vacío, estableciendo null');
        processedUpdates.cells = null;
      }
    }
    
    console.log('updateUser - datos procesados:', JSON.stringify(processedUpdates));
    console.log('updateUser - cells final:', JSON.stringify(processedUpdates.cells));
    
    const response = await fetch(`${API_URL}/users/${email}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(processedUpdates),
    });
    if (!response.ok) throw new Error('Error al actualizar usuario');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar usuario:', error);
    throw error;
  }
};

export const deleteUser = async (email) => {
  try {
    const response = await fetch(`${API_URL}/users/${email}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar usuario');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar usuario:', error);
    throw error;
  }
};

export const changePassword = async (email, currentPassword, newPassword) => {
  try {
    const response = await fetch(`${API_URL}/users/${email}/password`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ currentPassword, newPassword }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Error al cambiar contraseña');
    }
    
    return data;
  } catch (error) {
    console.error('Error al cambiar contraseña:', error);
    throw error;
  }
};

export const resetPassword = async (email, newPassword, adminEmail) => {
  try {
    console.log('=== FRONTEND resetPassword ===');
    console.log('URL:', `${API_URL}/users/${email}/reset-password`);
    console.log('Datos a enviar:', { newPassword: '***', adminEmail });
    
    const response = await fetch(`${API_URL}/users/${email}/reset-password`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ newPassword, adminEmail }),
    });
    
    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);
    
    // Si es 404, significa que la ruta no existe en el servidor
    if (response.status === 404) {
      throw new Error('La funcionalidad de resetear contraseña no está disponible en el servidor. Por favor, contacta al administrador del sistema.');
    }
    
    // Verificar si la respuesta es JSON válido
    const contentType = response.headers.get('content-type');
    console.log('Content-Type:', contentType);
    
    if (!contentType || !contentType.includes('application/json')) {
      const textResponse = await response.text();
      console.error('Respuesta no es JSON:', textResponse.substring(0, 200) + '...');
      
      if (response.status === 404) {
        throw new Error('La ruta de resetear contraseña no existe en el servidor. Asegúrate de que el servidor tenga la versión más reciente del código.');
      }
      
      throw new Error(`El servidor devolvió una respuesta inesperada (${response.status}). Por favor, contacta al administrador.`);
    }
    
    const data = await response.json();
    console.log('Response data:', data);
    
    if (!response.ok) {
      throw new Error(data.error || 'Error al resetear contraseña');
    }
    
    return data;
  } catch (error) {
    console.error('Error al resetear contraseña:', error);
    
    // Si es un error de red o fetch
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('No se pudo conectar con el servidor. Verifica tu conexión a internet.');
    }
    
    throw error;
  }
};

// Funciones para clientes
export const loadClients = async () => {
  try {
    const response = await fetch(`${API_URL}/clients`);
    if (!response.ok) throw new Error('Error al cargar clientes');
    return await response.json();
  } catch (error) {
    console.error('Error al cargar clientes:', error);
    throw error;
  }
};

export const createClient = async (client) => {
  try {
    const response = await fetch(`${API_URL}/clients`, {
      method: 'POST',
      headers,
      body: JSON.stringify(client),
    });
    if (!response.ok) throw new Error('Error al crear cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al crear cliente:', error);
    throw error;
  }
};

export const updateClient = async (id, updates) => {
  try {
    const response = await fetch(`${API_URL}/clients/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Error al actualizar cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar cliente:', error);
    throw error;
  }
};

export const deleteClient = async (id) => {
  try {
    const response = await fetch(`${API_URL}/clients/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar cliente:', error);
    throw error;
  }
};

// Funciones para juntas
export const createMeeting = async (meeting) => {
  try {
    const response = await fetch(`${API_URL}/meetings`, {
      method: 'POST',
      headers,
      body: JSON.stringify(meeting),
    });
    if (!response.ok) throw new Error('Error al crear junta');
    return await response.json();
  } catch (error) {
    console.error('Error al crear junta:', error);
    throw error;
  }
};

export const updateMeeting = async (id, updates) => {
  try {
    const response = await fetch(`${API_URL}/meetings/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Error al actualizar junta');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar junta:', error);
    throw error;
  }
};

export const deleteMeeting = async (id) => {
  try {
    const response = await fetch(`${API_URL}/meetings/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar junta');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar junta:', error);
    throw error;
  }
};
